import React from "react"
import SportsWordleGame from "~/components/SportsWordleGame"

export default function SportsWordleScreen() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-purple-50">
      <SportsWordleGame />
    </div>
  )
}
